import printItemHistoryComponent from './item_history.component';

let printItemHistoryModule = angular.module('printItemHistory', [
])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$stateProvider
			.state('printItemHistory', {
				url: '/print-item-history',
				component: 'printItemHistory',
			});
	})

	.component('printItemHistory', printItemHistoryComponent)

	.name;

export default printItemHistoryModule;


// WEBPACK FOOTER //
// ./client/app/components/item/print/index.js